import {
  getLocalStorageItem,
  removeLocalStorageItem,
  setLocalStorageItem,
} from "common/utils/storage/local-storage";
import {
  getRelatedStorageItem,
  getRelatedStorageItems,
  getStorageItem,
  clearRelatedStorageItems,
  removeStorageItem,
  setRelatedStorageItem,
  setStorageItem,
} from "common/utils/storage/legacy-storage";
import {
  deleteAllFromIndex,
  deleteIDBValue,
  getAllFromIndex,
  getIDBValue,
  putIDBValue,
} from "common/utils/storage/idb";

import {
  BUDGET_IDX_KEYPATH,
  BUDGET_IDX_NAME,
  BUDGET_STORE,
  CURRENT_BUDGET,
  NEW_PREFIX,
} from "features/budget/budget.constants";
import steps from "features/budget/wizard/state/stepper.data";

export async function getBudget(id = null) {
  const currentBudgetId = id ?? getLocalStorageItem(CURRENT_BUDGET);

  if (currentBudgetId === null) {
    return undefined;
  }

  const budget = await getIDBValue(BUDGET_STORE, currentBudgetId);
  return budget;
}

// eslint-disable-next-line camelcase
export function LEGACY_getBudget(id = null) {
  const currentBudgetId = id ?? getLocalStorageItem(CURRENT_BUDGET);

  if (currentBudgetId === null) {
    return undefined;
  }

  const budget = getStorageItem(currentBudgetId);
  return budget;
}

export async function deleteBudget(id = null) {
  const currentBudgetId = id ?? getLocalStorageItem(CURRENT_BUDGET);

  if (currentBudgetId !== null) {
    await deleteIDBValue(BUDGET_STORE, currentBudgetId);
    removeLocalStorageItem(CURRENT_BUDGET);
  }
}

// eslint-disable-next-line camelcase
export function LEGACY_deleteBudget(id = null) {
  const currentBudgetId = id ?? getLocalStorageItem(CURRENT_BUDGET);

  if (currentBudgetId !== null) {
    removeStorageItem(currentBudgetId);
    removeLocalStorageItem(CURRENT_BUDGET);
  }
}

export async function saveStepData(stepIndex, values) {
  let currentBudgetId = getLocalStorageItem(CURRENT_BUDGET);

  let budgetInDB;
  if (currentBudgetId) {
    budgetInDB = await getIDBValue(BUDGET_STORE, currentBudgetId);
  } else {
    currentBudgetId = `${NEW_PREFIX}${Date.now()}`;
    setLocalStorageItem(CURRENT_BUDGET, currentBudgetId);
  }

  const upserted = await putIDBValue(
    BUDGET_STORE,
    {
      ...budgetInDB,
      [steps[stepIndex].idbKey]: values,
    },
    currentBudgetId,
  );

  return Boolean(upserted);
}

// eslint-disable-next-line camelcase
export function LEGACY_saveStepData(stepIndex, values) {
  let currentBudgetId = getLocalStorageItem(CURRENT_BUDGET);

  let budgetInDB;
  if (currentBudgetId) {
    budgetInDB = getStorageItem(currentBudgetId);
  } else {
    currentBudgetId = `${NEW_PREFIX}${Date.now()}`;
    setLocalStorageItem(CURRENT_BUDGET, currentBudgetId);
  }

  setStorageItem(currentBudgetId, {
    ...budgetInDB,
    [steps[stepIndex].idbKey]: values,
  });
}

export async function getStepData(stepIndex) {
  const currentBudgetId = getLocalStorageItem(CURRENT_BUDGET);
  if (currentBudgetId !== null) {
    const budget = await getIDBValue(BUDGET_STORE, currentBudgetId);

    return budget?.[steps[stepIndex].idbKey];
  }
  return undefined;
}

// eslint-disable-next-line camelcase
export function LEGACY_getStepData(stepIndex) {
  const currentBudgetId = getLocalStorageItem(CURRENT_BUDGET);
  if (currentBudgetId !== null) {
    const budget = getStorageItem(currentBudgetId);

    return budget?.[steps[stepIndex].idbKey];
  }
  return undefined;
}

export async function saveBudgetRelatedValue(storeName, id, data) {
  const currentBudgetId = getLocalStorageItem(CURRENT_BUDGET);

  const valueInDB = await getIDBValue(storeName, id);
  await putIDBValue(storeName, {
    ...valueInDB,
    ...data,
    [BUDGET_IDX_KEYPATH]: currentBudgetId,
  });
}

// eslint-disable-next-line camelcase
export function LEGACY_saveBudgetRelatedValue(collection, id, data) {
  const currentBudgetId = getLocalStorageItem(CURRENT_BUDGET);

  const valueInStorage = getRelatedStorageItem(currentBudgetId, collection, id);
  setRelatedStorageItem(currentBudgetId, collection, id, {
    ...valueInStorage,
    ...data,
  });
}

export async function getBudgetRelatedValues(storeName) {
  const currentBudgetId = getLocalStorageItem(CURRENT_BUDGET);

  const result = await getAllFromIndex(
    storeName,
    BUDGET_IDX_NAME,
    currentBudgetId,
  );
  return result;
}

// eslint-disable-next-line camelcase
export function LEGACY_getBudgetRelatedValues(collection) {
  const currentBudgetId = getLocalStorageItem(CURRENT_BUDGET);

  return getRelatedStorageItems(currentBudgetId, collection);
}

export async function clearBudgetRelatedValues(storeName) {
  const currentBudgetId = getLocalStorageItem(CURRENT_BUDGET);
  await deleteAllFromIndex(storeName, BUDGET_IDX_NAME, currentBudgetId);
}

// eslint-disable-next-line camelcase
export function LEGACY_clearBudgetRelatedValues(collection) {
  const currentBudgetId = getLocalStorageItem(CURRENT_BUDGET);

  clearRelatedStorageItems(currentBudgetId, collection);
}
